import { DEFAULT_TOTAL_RECORDS } from "utils/constants";
import zoneLocalStorageId from "utils/zone";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchPatient = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );
  const sub_franchise = Number(localStorage.getItem("sub_franchise"));

  let params = {
    limit,
    page_no,
    zone_id,
    ...filter,
  };

  if (
    f_is_franchise_employee === 1
      ? true
      : f_is_super_franchise === 1
      ? true
      : sub_franchise === 1
      ? true
      : false
  ) {
    params = {
      ...params,
      f_is_franchise_employee,
      f_franchise_id,
      f_is_super_franchise,
    };
  }

  return axiosInstance.get(EndPoints.PATIENT.LIST, { params });
};

export const createPatient = (payload) => {
  return axiosInstance.post(EndPoints.PATIENT.CREATE, payload);
};

export const updatePatient = (payload) => {
  return axiosInstance.put(EndPoints.PATIENT.UPDATE, payload);
};

export const deletePatient = (payload) => {
  const url = EndPoints.PATIENT.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadCSV = () => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );
  return axiosInstance.put(
    `${
      EndPoints.PATIENT.DOWNLOAD_CSV
    }?zone_id=${zoneLocalStorageId()}&f_is_franchise_employee=${f_is_franchise_employee}&f_franchise_id=${f_franchise_id}&f_is_super_franchise=${f_is_super_franchise}`,
    {},
    {
      responseType: "blob",
    }
  );
};
